import DashboardData from "../components/DashboardData";
import DashboardFilter from "../components/DashboardFilter";
import useDashboardHistory from "../hooks/useDashboardHistory";
import useDashboardStore from "../store/dashboardStore";
import useUserStore from "../store/userStore";

function Dashboard() {
  const token = useUserStore((state) => state.token);
  const params = useDashboardStore((state) => state.params);

  const { data, isLoading, error } = useDashboardHistory(token, params);

  if (isLoading) return <div className="container">Loading...</div>;
  if (error) return <div className="container">Error: {error.message}</div>;
  console.log(data);

  return (
    <div className="container">
      <DashboardFilter />
      <DashboardData data={data} />
    </div>
  );
}

export default Dashboard;
